<template>
    <v-list>
        <v-list-item v-for="app in appTypes" :key="app.name">
            <SoliBtn
                block
                :text="app.name"
                color="soli-grey"
                outlined
                @click="$emit('input', app)"
                :disabled="app.disabled"
            ></SoliBtn
        ></v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            default: null,
        },
        bgEventClicked: {
            type: String,
            default: null,
        },
        overrideServices: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            appTypes: {
                assessment: {
                    name: "Assessment",
                    originalType: "Assessment",
                    assessment: true,
                    disabled: false,
                    recurring: false,
                },
                weeklyLesson: {
                    name: "Weekly Lesson",
                    originalType: "Weekly Lesson",
                    weeklyLesson: true,
                    disabled: false,
                    recurring: true,
                },
                reschedule: {
                    name: "Reschedule",
                    originalType: "Weekly Lesson",
                    reschedule: true,
                    disabled: false,
                    recurring: false,
                },
                dropIn: {
                    name: "Drop-In",
                    originalType: "Drop-In",
                    dropIn: true,
                    disabled: false,
                    recurring: false,
                },
                hold: {
                    name: "Hold",
                    originalType: "Hold",
                    hold: true,
                    disabled: false,
                    recurring: null,
                },
                event: {
                    name: "Event",
                    originalType: "Event",
                    event: true,
                    disabled: false,
                    recurring: null,
                },
            },
        };
    },
    methods: {
        setTeacherAppTypes(arg) {
            Object.values(this.appTypes).forEach((type) => {
                this.appTypes.weeklyLesson.disabled =
                    !arg?.assignment?.recurrence;
                if (!arg?.assignment) return;
                type.disabled =
                    !arg.assignment.availability.lesson_types.includes(
                        type.name
                    );
            });
        },
        setAppTypesByPermissions(arg) {
            this.appTypes.assessment.disabled = !this.can(
                "Book student assessments"
            );

            let bookingSelf =
                this.$page.props.auth.user.id == arg?.assignment?.user_id ||
                !arg?.assignment;
            let canBookOthers = this.can("Manage location schedule");
            let recurringAssignment = arg?.assignment?.recurrence;

            this.appTypes.weeklyLesson.disabled =
                (!arg?.assignment && !!arg) ||
                (!bookingSelf && !canBookOthers) ||
                recurringAssignment == false ||
                this.bgEventClicked == "Weekly Lesson";
            this.appTypes.dropIn.disabled =
                arg?.assignment && !bookingSelf && !canBookOthers;
            this.appTypes.hold.disabled =
                !bookingSelf &&
                !canBookOthers &&
                !this.can("Manage location room holds");
            this.appTypes.event.disabled =
                arg?.assignment && !bookingSelf && !canBookOthers;
        },
    },
    mounted() {
        //if (!this.event) return;
        this.setTeacherAppTypes(this.event);
        if (!this.can("Book student assessments")) {
            this.setAppTypesByPermissions(this.event);
        }
    },
    watch: {
        overrideServices(val) {
            if (val) {
                this.setAppTypesByPermissions(this.event);
            } else {
                this.setTeacherAppTypes(this.event);
            }
        },
    },
};
</script>
